import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CreateUser, } from '../models/create-user.model';
import { User, UsersListElem } from '../models/user.model';


@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private readonly http: HttpClient) { }

  createAdminUser(user: CreateUser): Observable<any> {  // N.B. Tramite API è possibile creare solamente utenti di ruolo Admin
    return this.http.post<User>(`${environment.apiGatewayUrl}/ugc/api/v1/users`, user);
  }

  listAdminUsers() {
    return this.http.get<UsersListElem[]>(`${environment.apiGatewayUrl}/ugc/api/v1/users?role=adm`);
  }

  userDetail(userdId: string) {
    return this.http.get<User>(`${environment.apiGatewayUrl}/ugc/api/v1/users/${userdId}`);
  }

  getGroupAssociableUsers(groupId: string): Observable<User[]> {
    return this.http.get<User[]>(`${environment.apiGatewayUrl}/ugc/api/v1/groups/${groupId}/users/notin`);
  }

  disableUser(userId: string) {
    return this.http.post<{}>(`${environment.apiGatewayUrl}/ugc/api/v1/users/disable/${userId}`, {});
  }

  enableUser(userId: string) {
    return this.http.post<{}>(`${environment.apiGatewayUrl}/ugc/api/v1/users/enable/${userId}`, {});
  }

  resendFirstAccessEmail(email: string) {
    return this.http.post<{ status: string, message: string }>(`${environment.apiGatewayUrl}/ugc/api/v1/email/first-access/resend`, { email });
  }

  deleteUser(userId: string) {
    return this.http.delete<{ status: string, message: string }>(`${environment.apiGatewayUrl}/ugc/api/v1/users/${userId}`);
  }
}
